import React from 'react';
import { Link } from 'operation-diameter';

export default {
  title: 'Submit your application below to get an instant funding decision',
  mainParagraph: () => (
    <>
      We will run a credit search on your client’s personal and business credit
      reports. <strong>This search does not affect their credit score.</strong>{' '}
      We may need to ask you to upload bank statements or accounts before we can
      give you a decision.
    </>
  ),
  getInstantDecision: 'Get your instant decision',
  cifasParagraph: () => (
    <>
      The personal data you’ve provided will be shared with fraud prevention
      agencies, who use it to prevent fraud, money laundering, and to verify
      your client’s identity. If fraud is detected, your client could be refused
      services, finance or employment. Further details can be found in our{' '}
      <Link href='/uk/legal/privacy-policy/' size='small' isExternal>
        privacy policy
      </Link>
      .
    </>
  )
};
